export default "__VITE_ASSET__BidCdDRd__"